import { render, staticRenderFns } from "./regulation-docs.vue?vue&type=template&id=6cbc0fb4"
import script from "./regulation-docs.vue?vue&type=script&lang=js"
export * from "./regulation-docs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports